import React from 'react';
import mixpanel from 'mixpanel-browser';

import { Button, Link, TextField } from '@mui/material';

import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { FaFacebookF } from 'react-icons/fa';

import { loggingInUser, loggedInUser } from '../../actions';

import { API_ENDPOINT } from '../../constants';

import {
  LOGIN,
  SIGN_UP_CAPITAL_FIRST_LETTER,
  Forgot_Password,
  email,
  emailLabel,
  emailRequired,
  emailPattern,
  password,
  passwordLabel,
  passwordRequired,
  SIGN_IN_WITH_GOOGLE,
  SIGN_IN_WITH_FACEBOOK,
} from '../../constants/Forms';

export const LoginForm = ({
  path,
  loginButtonText = LOGIN,
  isOnEmailRatesModal,
  handleBacktoEmailRates,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
  } = useForm();
  const dispatch = useDispatch();

  const { loading } = useSelector(({ userReducer: { loading } }) => ({
    loading,
  }));

  const handleOnUpKeyMixPanelTracking = (formField) => {
    mixpanel.track('Login Form', {
      [formField]: getValues(formField) || formField,
      path,
    });
  };

  const handleGoogleLogin = () => {
    mixpanel.track('Google Auth login', {
      path,
      destination_path: '/auth/google',
    });
    window.location.href = `${API_ENDPOINT}/auth/google`;
  };

  const handleFacebookLogin = () => {
    mixpanel.track('Facebook Auth login', {
      path,
      destination_path: '/auth/facebook',
    });
    window.location.href = `${API_ENDPOINT}/auth/facebook`;
  };

  const onSubmit = (data) => {
    mixpanel.track('Login Form', {
      action: 'Submit',
    });
    dispatch(loggingInUser);
    dispatch(loggedInUser({ user: data }));
    setValue(email, '');
    setValue(password, '');
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="login-input-wrapper">
        <TextField
          className={email}
          error={!!errors[email]}
          helperText={errors[email]?.message}
          id={email}
          name={email}
          placeholder={emailLabel}
          variant="outlined"
          autoComplete="off"
          sx={{ backgroundColor: 'rgb(240, 240, 240)', borderRadius: '10px' }}
          {...register(email, {
            required: emailRequired,
            pattern: emailPattern,
          })}
          onKeyUp={(e) => handleOnUpKeyMixPanelTracking(e.target.name)}
        />{' '}
      </div>
      <div className="login-input-wrapper">
        <TextField
          className={password}
          error={!!errors[password]}
          helperText={errors[password]?.message}
          id={password}
          placeholder={passwordLabel}
          name={password}
          variant="outlined"
          type={password}
          autoComplete="off"
          sx={{ backgroundColor: 'rgb(240, 240, 240)', borderRadius: '10px' }}
          {...register(password, {
            required: passwordRequired,
          })}
        />{' '}
      </div>
      <div className="login-form-button-row" style={isOnEmailRatesModal ? { float: 'none' } : {}}>
        {isOnEmailRatesModal && (
          <Button
            variant="outline"
            sx={{
              color: 'black',
              textDecoration: 'none',
              padding: 0,
              textTransform: 'initial',
              fontWeight: 400,
              fontSize: '16px',
            }}
            onClick={() => handleBacktoEmailRates()}
          >
            {SIGN_UP_CAPITAL_FIRST_LETTER}
          </Button>
        )}
        <Link
          variant="outline"
          sx={{ color: 'black', textDecoration: 'none' }}
          onClick={() => handleOnUpKeyMixPanelTracking('forgot_password')}
          href="/forgot_password"
        >
          {Forgot_Password}
        </Link>
      </div>
      <div className="login-button-wrapper">
        <Button className="loginBtn" disabled={loading} type="submit">
          {loginButtonText}
        </Button>
      </div>
      <Button
        variant="outlined"
        className="googleBtn"
        onClick={handleGoogleLogin}
        startIcon={
          <img
            src="https://developers.google.com/identity/images/g-logo.png"
            alt="Google"
            width="18"
            height="18"
          />
        }
      >
        {SIGN_IN_WITH_GOOGLE}
      </Button>
      <Button
        variant="contained"
        className="facebookBtn"
        onClick={handleFacebookLogin}
        startIcon={<FaFacebookF />}
      >
        {SIGN_IN_WITH_FACEBOOK}
      </Button>
    </form>
  );
};
